/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../infra/hooks';
import { jobInfoType } from '../../../common/interfaces/myProfile/personalDetails/jobInfo';
import { personalInfoType } from '../../../common/interfaces/myProfile/personalDetails/personalInfo';
import { emergencyContactType } from '../../../common/interfaces/myProfile/personalDetails/emergencyContactType';
import { bankInfoType } from '../../../common/interfaces/myProfile/personalDetails/bankInfoType';
import { aboutMeType } from '../../../common/interfaces/myProfile/personalDetails/aboutMeType';
import AuthInterface from '../../../infra/aggregates/AuthInterface';

import { dashboardService } from '../../../api/services/dashboardService';
import { personalInfoReducer } from '../../../infra/aggregates/myProfile/personalInfoSlice';
import { jobInfoReducer } from '../../../infra/aggregates/myProfile/jobInfoSlice';
import { getEmergencyDetailReducer } from '../../../infra/aggregates/myProfile/emergencyContactSlice';
import { getBankInfoReducer } from '../../../infra/aggregates/myProfile/bankInfoSlice';
import { getAllEmployeeSkills } from '../../../infra/aggregates/myProfile/skillsSlice';
import { getAboutMe } from '../../../infra/aggregates/myProfile/aboutMeSlice';
import { setPersonalDetailLoading } from '../../../infra/aggregates/myProfile/personalDetailLoaderSlice';
import { user_login } from '../../../infra/aggregates/authSlice';
import {
  setEditAccess,
  setRoleInfo,
  setViewAccess,
} from '../../../infra/aggregates/UserRoleInfo';
import _ from 'lodash';
import { setConigMenu } from '../../../infra/aggregates/sideMenuSlice';

interface PropsValue {
  setEmpNameDesignation: (data: any) => void;
  getempProPic: (data: any) => void;
}
function DTOPersonalDetails({
  setEmpNameDesignation,
  getempProPic,
}: PropsValue) {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  let personal_Info_data: personalInfoType = {
    firstName: '',
    lastName: '',
    DOB: new Date(),
    gender: '',
    martialStatus: '',
    country: '',
    email: '',
    phone: '',
    countryId: 0,
    genderId: 0,
    maritalStatusId: 0,
    state: '',
    stateId: 0,
    education: '',
    religious: '',
    nationalityId: 0,
    nationalityName: '',
  };

  let job_Info_data: jobInfoType = {
    staffId: 0,
    hireDate: new Date(),
    departmentName: '',
    departmentId: 0,
    employeeType: '',
    contractType: '',
    employeeCategory: '',
    payrollType: '',
    contractTypeId: 0,
    employeeCategoryId: 0,
    employeeTypeId: 0,
    payrollTypeId: 0,
    extNo: '',
  };

  let emergency_contact_data: emergencyContactType = {
    emergencyContactNumber: 0,
    emergencyPersonName: '',
    emergencyCountry: '',
    emergencyEmail: '',
    emergencyRelationship: '',
  };
  let bank_data: bankInfoType = {
    accountName: '',
    accountNo: 0,
    bankName: '',
    IBAN: '',
    MOL: '',
    UAN: '',
    ifsc: '',
    routing_number: '',
  };

  let about_me_data: aboutMeType = {
    about_me: '',
  };

  async function getJobInfo() {
    dispatch(setPersonalDetailLoading(true));
    const employeeId = selector.authSlice.emp_id;
    const response = await dashboardService.getdashboardService(employeeId);
    if (response) {
      const { get_emp_details }: any = response;
      getempProPic(get_emp_details?.user?.profile_pic);
      //for getting data for the auth__slice
      const user_obj: AuthInterface = {
        user_id: get_emp_details?.user?.id,
        name: get_emp_details?.user?.name,
        username: get_emp_details?.user?.username,
        profile_pic: get_emp_details?.user?.profile_pic,
        email: get_emp_details?.user?.email,
        status: get_emp_details?.user?.status,
        company_id: get_emp_details?.company_id,
        designaion: get_emp_details?.emp_job_detail?.designation?.name,
        department: get_emp_details?.emp_job_detail?.department?.name,
        emp_id: get_emp_details?.id,
        department_id: get_emp_details?.emp_job_detail?.department?.id,
        staff_id: get_emp_details?.staff_id,
        hire_date: get_emp_details?.emp_job_detail?.hire_date,
        currency: get_emp_details?.company?.company_currency?.currency?.name,
      };
      dispatch(user_login(user_obj));
      about_me_data = {
        about_me: get_emp_details?.about,
      };
      personal_Info_data = {
        firstName: get_emp_details.first_name,
        lastName: get_emp_details.last_name,
        DOB: get_emp_details.dob,
        gender: get_emp_details?.gender_name?.name,
        genderId: get_emp_details?.gender_name?.id,
        martialStatus: get_emp_details?.marital_status?.name,
        maritalStatusId: get_emp_details?.marital_status?.id,
        country: get_emp_details?.country?.name,
        countryId: get_emp_details?.country?.id,
        email: get_emp_details?.email,
        phone: get_emp_details?.phone,
        stateId: get_emp_details?.state?.id,
        state: get_emp_details?.state?.name,
        education: get_emp_details?.education,
        religious: get_emp_details?.religious,
        nationalityId: get_emp_details?.country_of_birth?.id,
        nationalityName: get_emp_details?.country_of_birth?.name,
      };

      job_Info_data = {
        staffId: get_emp_details?.staff_id,
        hireDate: get_emp_details?.emp_job_detail?.hire_date,
        departmentName: get_emp_details?.emp_job_detail?.department?.name,
        departmentId: get_emp_details?.emp_job_detail?.department?.id,

        employeeType: get_emp_details?.emp_job_detail?.employee_type?.name,
        employeeTypeId: get_emp_details?.emp_job_detail?.employee_type?.id,
        contractType: get_emp_details?.emp_job_detail?.contract_type?.name,
        contractTypeId: get_emp_details?.emp_job_detail?.contract_type?.id,
        employeeCategory:
          get_emp_details?.emp_job_detail?.employee_category?.name,
        employeeCategoryId:
          get_emp_details?.emp_job_detail?.employee_category?.id,
        payrollType: get_emp_details?.emp_job_detail?.payroll_type?.name,
        payrollTypeId: get_emp_details?.emp_job_detail?.payroll_type?.id,
        extNo: get_emp_details?.ext_number,
        isDirectManager: get_emp_details?.emp_job_detail?.isDirectManager,
        isDirectManagerStffId:
          get_emp_details?.emp_job_detail?.isDirectManagerStaffId,
        grade: get_emp_details?.emp_job_detail?.grade?.name,
      };

      emergency_contact_data = {
        emergencyContactNumber: get_emp_details?.emergency_contact,
        emergencyPersonName: get_emp_details?.emergency_person,
        emergencyCountry: get_emp_details?.emergency_country,
        emergencyEmail: get_emp_details?.emergency_email,
        emergencyRelationship: get_emp_details?.emergency_relationship,
      };

      bank_data = {
        accountName: get_emp_details?.emp_bank_detail?.account_holder_name,
        accountNo: get_emp_details?.emp_bank_detail?.account_no,
        bankName: get_emp_details?.emp_bank_detail?.bank_name,
        IBAN: get_emp_details?.emp_bank_detail?.iban,
        MOL: get_emp_details?.emp_bank_detail?.mol,
        UAN: get_emp_details?.emp_bank_detail?.uan,
        ifsc: get_emp_details?.emp_bank_detail?.ifsc_code,
        routing_number: get_emp_details?.emp_bank_detail?.bank_routing_no,
      };

      dispatch(jobInfoReducer(job_Info_data));

      dispatch(personalInfoReducer(personal_Info_data));

      dispatch(getEmergencyDetailReducer(emergency_contact_data));
      dispatch(getBankInfoReducer(bank_data));
      dispatch(getAboutMe(about_me_data));

      dispatch(getAllEmployeeSkills(get_emp_details?.emp_skills));
      dispatch(setPersonalDetailLoading(false));
    } else {
      dispatch(setPersonalDetailLoading(false));

      return;
    }
  }
  const userId = useAppSelector((state: any) => state.authSlice.user_id);
  const locale = localStorage.getItem('emplang');
  async function getUserData() {
    dashboardService.getUserInfo(userId, locale).then((res: any) => {
      function checkPermission(res: any, permissionName: any) {
        return _.map(res, function (e) {
          const filter = e.role.role_has_permissions;
          const access = _.filter(filter, function (permissionObj: any) {
            return permissionObj?.permission?.name === permissionName;
          });
          return access;
        });
      }
      const editPermissions = checkPermission(res, 'Employee AD Edit Access');
      const viewPermissions = checkPermission(res, 'Employee AD View Access');
      dispatch(setRoleInfo(res[0].role));
      if (
        editPermissions.some((data) => data.length > 0) ||
        viewPermissions.some((data) => data.length > 0)
      ) {
        dispatch(setViewAccess(true));
      } else {
        dispatch(setViewAccess(false));
      }
      if (editPermissions.some((data) => data.length > 0)) {
        dispatch(setEditAccess(true));
      } else {
        dispatch(setEditAccess(false));
      }
    });
  }


  useEffect(() => {
    getJobInfo();
    setEmpNameDesignation({
      name: selector?.authSlice?.name,
      designation: selector?.authSlice?.designaion,
    });
    getUserData();
  }, []);

  useEffect(() => {
    setEmpNameDesignation({
      name:
        selector?.personalInfoSlice?.firstName +
        ' ' +
        selector?.personalInfoSlice?.lastName,
      designation: selector?.authSlice?.designaion,
      // profilePic: selector?.profilePicSlice?.profilePic,
    });
  }, [
    selector.personalInfoSlice,
    selector.authSlice,
    //selector?.profilePicSlice?.profilePic,
  ]);
  return <></>;
}
export default DTOPersonalDetails;
